import { render, staticRenderFns } from "./material.vue?vue&type=template&id=66448dce&scoped=true&"
import script from "./material.vue?vue&type=script&lang=js&"
export * from "./material.vue?vue&type=script&lang=js&"
import style0 from "./material.vue?vue&type=style&index=0&id=66448dce&lang=scss&scoped=true&"
import style1 from "./material.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66448dce",
  null
  
)

export default component.exports